module.exports = __webpack_public_path__ + "img/dnd-banner.8efb9ef3.png";